import React, { Dispatch, SetStateAction, useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { LuMoreVertical } from "react-icons/lu";
import ImportExcelButton from "../../../components/common/modal/ImportExcelButton";
import ModalDuplicateRow from "../../../components/common/modal/ModalDuplicateRow";
import { CategoryType } from "../../../types/category.type";
import { useNavigate } from "react-router-dom";

interface IOptions {
  category: CategoryType;
  setLoad: Dispatch<SetStateAction<number>>;
}

function Options({ category, setLoad }: IOptions) {
  const [anchorMenu, setAnchorMenu] = useState<HTMLButtonElement | null>(null);
  const [openModalDuplicate, setOpenModalDuplicate] = useState(false);
  const navigate = useNavigate();

  const handleCloseMenu = () => {
    setAnchorMenu(null);
  };

  return (
    <>
      {openModalDuplicate && (
        <ModalDuplicateRow
          apiCode={category?.apiCode}
          open={openModalDuplicate}
          onClose={() => setOpenModalDuplicate(false)}
          columns={category.columns}
          fields={category?.fields || []}
        />
      )}
      <Menu
        open={!!anchorMenu}
        anchorEl={anchorMenu}
        onClose={handleCloseMenu}
        keepMounted
      >
        <ImportExcelButton
          apiCode={category?.apiCode}
          columns={category.columns}
          refresh={() => setLoad((prev) => prev + 1)}
          renderDisplay={({ onClick }) => {
            return <MenuItem onClick={onClick}>Nhập excel</MenuItem>;
          }}
        />
        <MenuItem onClick={() => navigate(`/trash/${category.apiCode}`)}>
          Thùng rác
        </MenuItem>
        {/* <MenuItem onClick={() => setOpenExportExcel(true)}>Xuất excel</MenuItem> */}
        <MenuItem onClick={() => setOpenModalDuplicate(true)}>
          Kiểm tra trùng dữ liệu
        </MenuItem>
      </Menu>
      {/* Button */}
      <Button
        onClick={(e) => setAnchorMenu(e.currentTarget)}
        variant="contained"
        color="primary"
        size="small"
        sx={{
          boxShadow: "none",
          color: "common.white",
          textTransform: "none",
          "&:hover": { boxShadow: "none" },
        }}
        startIcon={<LuMoreVertical size={16} />}
      >
        Tùy chọn
      </Button>
    </>
  );
}

export default Options;
